module.exports = __webpack_public_path__ + "static/media/soccer.ba0f1ef6.svg";